import Lottie from 'lottie-react';
import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import Button from 'components/common/Button/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
`;

export const ContainerInformation = styled.div`
  margin: 48px 24px;

  @media (min-width: ${DEVICE.laptop}) {
    margin: 16px 24px;
  }
`;

export const Title = styled.h2.attrs({className: 'checkin-completed-modal__title'})`
  font-style: normal;
  font-weight: ${props => props.theme.fonts.fontWeight.bold};
  font-size: ${props => props.theme.fonts.sizes.largeL};
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.36px;
  color: ${props => props.theme.colors.$p10};
`;

export const Subtitle = styled.p.attrs({className: 'checkin-completed-modal__title'})`
  font-style: normal;
  font-weight: ${props => props.theme.fonts.fontWeight.regular};
  font-size: ${props => props.theme.fonts.sizes.small};
  line-height: 24px;
  color: ${props =>
    props.theme.hasTemplate
      ? props.theme.colors.branding.fontPrimary
      : props.theme.colors.$p10};
  text-align: center;
`;
export const ContainerButton = styled.div`
  @media (min-width: ${DEVICE.laptop}) {
    margin-top: 48px;
  }
`;

export const ConfirmButton = styled(Button)`
  margin: 0 auto;
  font-weight: ${props => props.theme.fonts.fontWeight.medium};
  font-size: ${props => props.theme.fonts.sizes.medium};
  letter-spacing: -0.15px;
  width: 205px;

  @media (min-width: ${DEVICE.mobileM}) {
    width: 327px;
  }
`;

export const StyledLottie = styled(Lottie)`
  width: 150px;
  height: 150px;
`;
